import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/notification.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-788a5476")

_pushScopeId("data-v-788a5476")
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "notification_ball bg_blue"
}
const _hoisted_3 = { class: "fev_text7" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: _imports_0,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/notifications')))
    }),
    (_ctx.notificationNumber != 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.notificationNumber > 9 ? "9+" : _ctx.notificationNumber), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})